/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */
export const invitationStatuses = Object.freeze({
  FAILED: 'failed',
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
});
